export const CardHistoryTrans = ({ dataHistory }) => {
    return (
        <div className={'CardHistoryTrans'}>
            <div className={'header'}>
                <h2>Транзакция №{dataHistory.transaction}</h2>
                <span>{dataHistory.status}</span>
            </div>
            <div className={'main'}>-</div>
        </div>
    )
}
